"use client";

import * as React from "react";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

import { cn } from "@/lib/utils";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        cell: "text-center text-sm p-0 relative [&:has([aria-selected])]:bg-secondary [&:has([aria-selected])]:text-white [&:has([aria-selected])]:rounded-md",
        day: cn(
          "h-9 w-9 p-0 font-normal bg-secondary rounded-md hover:!bg-[#ecebeb] hover:!text-primary",
        ),
        day_outside: "bg-secondary hover:!bg-secondary rounded-md",
        day_selected: "bg-secondary hover:!bg-secondary rounded-md",
        day_range_middle: "bg-secondary hover:!bg-secondary rounded-md",
        day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        IconLeft: ({ ...props }) => (
          <ChevronLeftIcon className="size-4 flex justify-center items-center" />
        ),
        IconRight: ({ ...props }) => (
          <ChevronRightIcon className="size-4 flex justify-center items-center" />
        ),
      }}
      {...props}
    />
  );
}

Calendar.displayName = "Calendar";

export { Calendar };
